export enum Animations {
  LINE,
  FLASHING,
  EASE,
  NONE
}

export enum Sizes {
  SMALL = 'small',
  MIDDLE = 'middle',
  LARGE = 'large'
}

export enum LegendPosition {
  TOP = 'top',
  BOTTOM = 'bottom'
}

export enum ChartType {
  BAR = 'bar',
  LINE = 'line',
  DOT = 'dot',
  PIE = 'pie',
  RADAR = 'radar',
  DOUGHNUT = 'doughnut',
  SCATTER = 'scatter',
  BUBBLE = 'bubble',
  POLARAREA = 'polarArea',
  SPLINE = 'spline'
}

export enum ChartTypeHighChart {
  BAR = 'bar',
  LINE = 'line',
  PIE = 'pie',
  SCATTER = 'scatter',
  SPLINE = 'spline'
}

export enum CardType {
  DEFAULT = 'default',
  AVATAR = 'avatar',
  META = 'meta'
}

export enum Position {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom'
}

export enum ReportType {
  ARTICLE = 'article'
}

export enum ListType {
  BULLET = 'bullet',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  AVATAR = 'avatar'
}

export enum Shape {
  CIRCLE = 'circle',
  SQUARE = 'square'
}
export enum GalleryType {
  GRID = 'grid',
  YOUTUBE = 'youtube'
}
export enum VideoType {
  MEDIA = 'media',
  YOUTUBE = 'youtube'
}
